export default __webpack_public_path__ + "static/media/AdobeStock_321604276_x3.8133018f.jpg";